import { COLORS } from 'assets/styled/colors';
import styled, { css } from 'styled-components';

interface StyledProps {
  imageLoaded: boolean;
  isSelected: boolean;
  isDarkMode: boolean;
  isClickable: boolean;
}

export const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
  border-radius: 10rem;
  border: 1rem solid ${COLORS.GRAY_300};
  padding: 10rem;
  background-color: ${COLORS.WHITE};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${(props: StyledProps) =>
    props.isSelected &&
    css`
      border: 1rem solid ${COLORS.GREEN};
      background-color: ${props.isDarkMode
        ? COLORS.GRAY_200
        : COLORS.LIGHT_GREEN};
    `}
  ${(props: StyledProps) =>
    props.isClickable &&
    css`
      cursor: pointer;
    `}
`;

export const CompanyLogoWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 10rem;
`;

export const imageStyle = css`
  width: 100%;
  object-fit: contain;
  border-radius: 20rem;
  cursor: pointer;
  max-height: 150rem;

  ${(props: StyledProps) =>
    props.imageLoaded
      ? css`
          max-width: 100%;
          object-fit: contain;
          border-radius: 20rem;
          cursor: pointer;
        `
      : css`
          width: 0;
          height: 0;
          opacity: 0;
        `};
`;

export const CompanyNameLabel = styled.label`
  font-size: 18rem;
  font-weight: 400;
  color: ${COLORS.BLACK};
  margin-bottom: 10rem;
  text-align: center;
`;

export const CustomerNumber = styled.label`
  font-size: 16rem;
  font-weight: 400;
  color: ${COLORS.GREEN};
  margin-bottom: 10rem;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: -10rem;
  right: -10rem;
  border-radius: 100%;
  border: 1rem solid ${COLORS.RED_100};
  background-color: ${COLORS.BACKGROUND};
  z-index: 1;
  padding: 5rem;

  &:hover {
    transform: scale(1.1);
    transition: transform ease-in-out 0.1s;
  }
`;
